import { printf, toText } from "../../../fable_modules/fable-library-js.4.19.0/String.js";
import { keyValueList } from "../../../fable_modules/fable-library-js.4.19.0/MapUtil.js";
import { ofArray, empty, singleton, append } from "../../../fable_modules/fable-library-js.4.19.0/List.js";
import { Types_RequestProperties } from "../../../fable_modules/Fable.Fetch.2.7.0/Fetch.fs.js";
import { Auto_generateBoxedDecoderCached_Z6670B51 } from "../../../fable_modules/Thoth.Json.10.4.1/./Decode.fs.js";
import { Quickfinder_QuickfinderResponse, Quickfinder_Information_$reflection, Quickfinder_QuickfinderResponse_$reflection } from "../../../../Bfs.Web.Data.Service.Contracts/Kundenportal.Contracts.fs.js";
import { CaseStrategy } from "../../../fable_modules/Thoth.Json.10.4.1/Types.fs.js";
import { errorString, Encoders } from "../../../../Bfs.Web.Portale/./Http.fs.js";
import { fromString } from "../../../../Bfs.Web.Portale/../Bfs.Web.Kundenportal/fable_modules/Thoth.Json.10.4.1/Decode.fs.js";
import { uncurry2 } from "../../../fable_modules/fable-library-js.4.19.0/Util.js";
import { array_type } from "../../../fable_modules/fable-library-js.4.19.0/Reflection.js";
import { IsQuickFinderSortierungAufsteigend_set, IsQuickFinderSortierungAufsteigend_get } from "../../../../Bfs.Web.Portale/Storage.fs.js";
import { Remote$1 } from "../../../../Bfs.Web.Portale/Types.fs.js";
import { Msg, Model } from "./Types.fs.js";
import { request, Loaded } from "../../../../Bfs.Web.Portale/Http.fs.js";
import { Cmd_none } from "../../../fable_modules/Fable.Elmish.4.2.0/cmd.fs.js";
import { Result_Map } from "../../../fable_modules/fable-library-js.4.19.0/Result.js";

export function Http_getRechnungDetails(nummer) {
    let arg;
    const response = fetch((arg = encodeURIComponent(nummer), toText(printf("/api/quickfinder/rechnung?nummer=%s"))(arg)), keyValueList(append(singleton(new Types_RequestProperties(4, ["include"])), empty()), 1));
    const decoder = Auto_generateBoxedDecoderCached_Z6670B51(Quickfinder_QuickfinderResponse_$reflection(), new CaseStrategy(1, []), Encoders());
    return response.then((response_1_1) => {
        if (!(response_1_1.ok)) {
            throw new Error(errorString(response_1_1));
        }
        else {
            const pr = response_1_1.text();
            return pr.then((res) => {
                const matchValue = fromString(uncurry2(decoder), res);
                if (matchValue.tag === 1) {
                    throw new Error(matchValue.fields[0]);
                }
                else {
                    return matchValue.fields[0];
                }
            });
        }
    });
}

export function Http_getRechnungDetailsLegacy(nummer) {
    let arg;
    const response = fetch((arg = encodeURIComponent(nummer), toText(printf("/api/quickfinder/rechnunglegacy?nummer=%s"))(arg)), keyValueList(append(singleton(new Types_RequestProperties(4, ["include"])), empty()), 1));
    const decoder = Auto_generateBoxedDecoderCached_Z6670B51(array_type(Quickfinder_Information_$reflection()), new CaseStrategy(1, []), Encoders());
    return response.then((response_1_1) => {
        if (!(response_1_1.ok)) {
            throw new Error(errorString(response_1_1));
        }
        else {
            const pr = response_1_1.text();
            return pr.then((res) => {
                const matchValue = fromString(uncurry2(decoder), res);
                if (matchValue.tag === 1) {
                    throw new Error(matchValue.fields[0]);
                }
                else {
                    return matchValue.fields[0];
                }
            });
        }
    });
}

export function Http_getRechnungDetailsById(id) {
    const response = fetch(toText(printf("/api/quickfinder/rechnungbyid?rechnungid=%O"))(id), keyValueList(append(singleton(new Types_RequestProperties(4, ["include"])), empty()), 1));
    const decoder = Auto_generateBoxedDecoderCached_Z6670B51(array_type(Quickfinder_Information_$reflection()), new CaseStrategy(1, []), Encoders());
    return response.then((response_1_1) => {
        if (!(response_1_1.ok)) {
            throw new Error(errorString(response_1_1));
        }
        else {
            const pr = response_1_1.text();
            return pr.then((res) => {
                const matchValue = fromString(uncurry2(decoder), res);
                if (matchValue.tag === 1) {
                    throw new Error(matchValue.fields[0]);
                }
                else {
                    return matchValue.fields[0];
                }
            });
        }
    });
}

export function Http_getRechnungDetailsFt(nummer) {
    let arg;
    const response = fetch((arg = encodeURIComponent(nummer), toText(printf("/api/quickfinder/rechnungft?nummer=%s"))(arg)), keyValueList(append(singleton(new Types_RequestProperties(4, ["include"])), empty()), 1));
    const decoder = Auto_generateBoxedDecoderCached_Z6670B51(Quickfinder_QuickfinderResponse_$reflection(), new CaseStrategy(1, []), Encoders());
    return response.then((response_1_1) => {
        if (!(response_1_1.ok)) {
            throw new Error(errorString(response_1_1));
        }
        else {
            const pr = response_1_1.text();
            return pr.then((res) => {
                const matchValue = fromString(uncurry2(decoder), res);
                if (matchValue.tag === 1) {
                    throw new Error(matchValue.fields[0]);
                }
                else {
                    return matchValue.fields[0];
                }
            });
        }
    });
}

export function Http_downloadUrlDokumentAnfrage(id) {
    return toText(printf("/api/quickfinder/downloaddokumentanfrage?id=%O"))(id);
}

export function Http_downloadUrlSammelrechnung(id) {
    return toText(printf("/api/quickfinder/downloadsammelrechnung?id=%O"))(id);
}

export function State_init(page, user, lastModel) {
    const setting = IsQuickFinderSortierungAufsteigend_get();
    if (page.tag === 1) {
        return [new Model(page.fields[0], setting, new Remote$1(1, []), new Remote$1(1, [])), singleton((dispatch_1) => {
            dispatch_1(new Msg(1, [page.fields[1]]));
        })];
    }
    else {
        const nummer = page.fields[0];
        return [new Model(nummer, setting, new Remote$1(1, []), new Remote$1(1, [])), singleton((dispatch) => {
            dispatch(new Msg(0, [nummer]));
        })];
    }
}

export function State_update(msg, model) {
    let matchValue;
    switch (msg.tag) {
        case 2:
            return [new Model(model.Rechnungsnummer, model.AufsteigendSortieren, model.Information, Loaded(msg.fields[0])), Cmd_none()];
        case 4: {
            const newValue = !model.AufsteigendSortieren;
            IsQuickFinderSortierungAufsteigend_set(newValue);
            return [new Model(model.Rechnungsnummer, newValue, model.Information, model.QuickfinderResponse), Cmd_none()];
        }
        case 1:
            return [new Model(model.Rechnungsnummer, model.AufsteigendSortieren, model.Information, new Remote$1(1, [])), request(Http_getRechnungDetailsById, msg.fields[0], (Item_3) => (new Msg(3, [Item_3])))];
        case 3:
            return [new Model(model.Rechnungsnummer, model.AufsteigendSortieren, model.Information, Loaded(Result_Map((i_1) => (new Quickfinder_QuickfinderResponse(0, [ofArray(i_1)])), msg.fields[0]))), Cmd_none()];
        case 5:
            return [model, Cmd_none()];
        default: {
            const nummer = msg.fields[0];
            return [new Model(model.Rechnungsnummer, model.AufsteigendSortieren, model.Information, new Remote$1(1, [])), (matchValue = nummer[0], (matchValue === "^") ? request(Http_getRechnungDetails, nummer.slice(1, nummer.length), (Item_1) => (new Msg(2, [Item_1]))) : ((matchValue === "~") ? request(Http_getRechnungDetailsLegacy, nummer.slice(1, nummer.length), (Item) => (new Msg(3, [Item]))) : request(Http_getRechnungDetailsFt, nummer, (Item_2) => (new Msg(2, [Item_2])))))];
        }
    }
}

//# sourceMappingURL=State.fs.js.map
